import * as React from "react";
import {connect} from "react-redux";
import * as selectors from "../selectors";
import DownloadState from "../DownloadState";
import {Radio, Form} from 'react-bootstrap';
import {Destination} from "../../../../integration/representation/contract";
import {
    setSrid, SetSrid
} from "../actions";

interface TagProps {
}

interface DispatchProps {
    doSetSrid: SetSrid
}

interface StateProps {
    destination: Destination;
    srid: string;
}

type Props = TagProps & StateProps & DispatchProps;

const mapStateToProps = (state: DownloadState): StateProps => {
    return {
        destination: selectors.destination(state),
        srid: selectors.srid(state)
    };
};

const mapDispatchToProps: DispatchProps = ({
    doSetSrid: setSrid
});


class Component extends React.Component<Props, {}> {

    handleSridChange(e: any, srid: any) {
        this.props.doSetSrid(srid);
    }

    render() {
        let { destination, srid } = this.props;

        return (
            <>
                {destination === "FKB" &&
                    <div className={"download-selection-box"}>
                        <h2>SRID</h2>
                        <p>Transformer geometrikoordinater til:</p>
                        <Form>
                            <Radio
                                checked={srid === "25832"}
                                onChange={(e) => this.handleSridChange(e, "25832")}>
                                UTM sone 32, EUREF89 (EPSG 25832)
                            </Radio>
                            <Radio
                                checked={srid === "25833"}
                                onChange={(e) => this.handleSridChange(e, "25833")}>
                                UTM sone 33, EUREF89 (EPSG 25833)
                            </Radio>
                            <Radio
                                checked={srid === "25834"}
                                onChange={(e) => this.handleSridChange(e, "25834")}>
                                UTM sone 34, EUREF89 (EPSG 25834)
                            </Radio>
                            <Radio
                                checked={srid === "25835"}
                                onChange={(e) => this.handleSridChange(e, "25835")}>
                                UTM sone 35, EUREF89 (EPSG 25835)
                            </Radio>
                            <Radio
                                checked={srid === "25836"}
                                onChange={(e) => this.handleSridChange(e, "25836")}>
                                UTM sone 36, EUREF89 (EPSG 25836)
                            </Radio>
                        </Form>
                    </div>
                }
            </>
        )
    }
}

export const SridSelection = connect(mapStateToProps, mapDispatchToProps)(Component);
